import { Pipe, PipeTransform } from '@angular/core';
import { SignRequestStatus } from '@dpr/enums';
import {
  DprReportSignRequestStatus,
  Signer,
} from '@dpr/models/digital-signature';

@Pipe({ name: 'eSignStatusColor' })
export class ESignStatusColorPipe implements PipeTransform {
  transform(data: Signer | DprReportSignRequestStatus): string {
    switch (data?.status) {
      case SignRequestStatus.Signed:
      case SignRequestStatus.SignerSigned:
        return 'success';
      case SignRequestStatus.ConvertError:
      case SignRequestStatus.SendingError:
      case SignRequestStatus.Declined:
      case SignRequestStatus.Cancelled:
      case SignRequestStatus.Expired:
      case SignRequestStatus.SignerEmailBounced:
      case SignRequestStatus.ProcessingError:
        return 'danger';
      default:
        return 'grey';
    }
  }
}
